import * as React from 'react';
import { TableCell, TableRow } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import { useIntl } from 'react-intl';
import { MonthlyReportRecipient } from 'redux/ducks/monthlyReportRecipients/types';
import { MonthlyReportTemplateType } from 'redux/ducks/settings';

export interface RecipientProps {
  recipient: MonthlyReportRecipient;
  reportTemplateType: MonthlyReportTemplateType;
  onEdit: (recipient: MonthlyReportRecipient) => void;
  onDelete: (recipient: MonthlyReportRecipient) => void;
}

export const Recipient: React.FC<RecipientProps> = ({
  recipient,
  reportTemplateType,
  onEdit,
  onDelete
}) => {
  const intl = useIntl();

  return (
    <TableRow className='recipientItem'>
      <TableCell
        title={intl.formatMessage({ id: 'edit' })}
        onClick={() => {
          onEdit(recipient);
        }}
      >
        {recipient.email}
      </TableCell>
      <TableCell title={intl.formatMessage({ id: 'edit' })} onClick={() => onEdit(recipient)}>
        {recipient.language}
      </TableCell>
      <TableCell title={intl.formatMessage({ id: 'edit' })} onClick={() => onEdit(recipient)}>
        {intl.formatMessage({
          id: `monthlyReportTemplate.${reportTemplateType.name}`
        })}
      </TableCell>
      <TableCell
        align='right'
        className='removeButton'
        title={intl.formatMessage({ id: 'data_table.delete' })}
        onClick={() => onDelete(recipient)}
      >
        <DeleteIcon />
      </TableCell>
    </TableRow>
  );
};
